// extracted by mini-css-extract-plugin
module.exports = {"content":"DeleteUserModal_content_mVAN8","innerContent":"DeleteUserModal_innerContent_1d-qQ","optionInput":"DeleteUserModal_optionInput_gAGhM"};